/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CreateImageParamsDto {
	file: {
		/** @format binary */
		file?: File;
	};
	/** @maxLength 100 */
	nameInt: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface UpdateImageParamsDto {
	/** @maxLength 100 */
	nameInt: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @maxLength 100 */
	fileName: string;
	lastChange: string;
}

import { type LANGUAGE, type REQ_SOURCE } from '@nfctron/nexus-core';
import { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse, type ResponseType } from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseType;
	/** request body */
	body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface NfctronApiParams
	extends Partial<{
		reqSource: REQ_SOURCE;
		version: string;
		locale: string | LANGUAGE;
	}> {}

export interface ApiConfig<SecurityDataType = unknown> {
	securityWorker?: (securityData: SecurityDataType | null) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
	nfctronApiWorker?: (nfctronApiParams: NfctronApiParams) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
	secure?: boolean;
	format?: ResponseType;
	instance: AxiosInstance;
}

export enum ContentType {
	Json = 'application/json',
	FormData = 'multipart/form-data',
	UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
	public instance: AxiosInstance;
	public securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
	public nfctronApiParams: NfctronApiParams | null = null;
	private nfctronApiWorker?: ApiConfig<SecurityDataType>['nfctronApiWorker'];
	private secure?: boolean;
	private format?: ResponseType;

	constructor({ securityWorker, nfctronApiWorker, secure, format, instance }: ApiConfig<SecurityDataType>) {
		this.instance = instance;
		this.secure = secure;
		this.format = format;
		this.securityWorker = securityWorker;
		this.nfctronApiWorker = nfctronApiWorker;
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	public setNfctronApiParams = (nfctronApiParams: NfctronApiParams) => {
		this.nfctronApiParams = nfctronApiParams;
	};

	private mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
		return {
			...this.instance.defaults,
			...params1,
			...(params2 || {}),
			// @ts-ignore
			headers: {
				...(this.instance.defaults.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	private createFormData(input: Record<string, unknown>): FormData {
		return Object.keys(input || {}).reduce((formData, key) => {
			const property = input[key];
			formData.append(
				key,
				property instanceof Blob ? property : typeof property === 'object' && property !== null ? JSON.stringify(property) : `${property}`,
			);
			return formData;
		}, new FormData());
	}

	public request = async <T = any, _E = any>({
		secure,
		path,
		type,
		query,
		format,
		body,
		...params
	}: FullRequestParams): Promise<AxiosResponse<T>> => {
		const secureParams =
			((typeof secure === 'boolean' ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
		const nfctronApiParams = this.nfctronApiWorker && this.nfctronApiParams ? (await this.nfctronApiWorker(this.nfctronApiParams)) || {} : {};
		const requestParams1 = this.mergeRequestParams(params, secureParams);
		const requestParams = this.mergeRequestParams(requestParams1, nfctronApiParams);
		const responseFormat = (format && this.format) || void 0;

		if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
			requestParams.headers = requestParams.headers ?? {};
			(requestParams.headers.common as any) = { Accept: '*/*' };
			(requestParams.headers.post as any) = {};
			(requestParams.headers.put as any) = {};

			body = this.createFormData(body as Record<string, unknown>);
		}

		return this.instance.request({
			...requestParams,
			headers: {
				...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
				...(requestParams.headers || {}),
			},
			params: query,
			responseType: responseFormat,
			data: body,
			url: path,
		});
	};
}

/**
 * @title NFCtron Root API
 * @version 0.439.0
 * @license Do not share
 * @baseUrl https://api.staging.nfctron.com/
 * @contact
 *
 * Root of NFCtron API.
 */
export class RootApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @name GetRoot
	 * @request GET:/
	 * @response `200` `void`
	 */
	getRoot = {
		id: '/',
		request: (params: RequestParams = {}) =>
			this.request<void, any>({
				path: `/`,
				method: 'GET',
				...params,
			}),
	};

	health = {
		/**
 * No description
 * 
 * @name GetHealth
 * @request GET:/health
 * @response `200` `{
  \** @example "ok" *\
    status?: string,
  \** @example {"database":{"status":"up"}} *\
    info?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {} *\
    error?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"database":{"status":"up"}} *\
    details?: Record<string,{
    status: string,
    [key: string]: any,

}>,

}` The Health Check is successful
 * @response `503` `{
  \** @example "error" *\
    status?: string,
  \** @example {"database":{"status":"up"}} *\
    info?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"redis":{"status":"down","message":"Could not connect"}} *\
    error?: Record<string,{
    status: string,
    [key: string]: any,

}>,
  \** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} *\
    details?: Record<string,{
    status: string,
    [key: string]: any,

}>,

}` The Health Check is not successful
 */
		getHealth: {
			id: '/health',
			request: (params: RequestParams = {}) =>
				this.request<
					{
						/** @example "ok" */
						status?: string;
						/** @example {"database":{"status":"up"}} */
						info?: Record<
							string,
							{
								status: string;
								[key: string]: any;
							}
						>;
						/** @example {} */
						error?: Record<
							string,
							{
								status: string;
								[key: string]: any;
							}
						>;
						/** @example {"database":{"status":"up"}} */
						details?: Record<
							string,
							{
								status: string;
								[key: string]: any;
							}
						>;
					},
					{
						/** @example "error" */
						status?: string;
						/** @example {"database":{"status":"up"}} */
						info?: Record<
							string,
							{
								status: string;
								[key: string]: any;
							}
						>;
						/** @example {"redis":{"status":"down","message":"Could not connect"}} */
						error?: Record<
							string,
							{
								status: string;
								[key: string]: any;
							}
						>;
						/** @example {"database":{"status":"up"},"redis":{"status":"down","message":"Could not connect"}} */
						details?: Record<
							string,
							{
								status: string;
								[key: string]: any;
							}
						>;
					}
				>({
					path: `/health`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	order = {
		/**
		 * No description
		 *
		 * @name GetOrderSpaydQr
		 * @request GET:/order/{orderId}/spayd-qr
		 * @response `200` `void`
		 */
		getOrderSpaydQr: {
			id: '/order/${orderId}/spayd-qr',
			request: (input: { orderId: string }, params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/order/${input.orderId}/spayd-qr`,
					method: 'GET',
					...params,
				}),
		},
	};
}
